import React, { Fragment } from 'react';

import { LoadingSpinner, PlatformProducerOrderWithProductionPlanDetails } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { GQLParty } from '@jewelutions/core-crm-server-api-client-domain';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

interface IProps {
  party: GQLParty;
  deliveryUnitId: string;
  itemCustomisations: string[];
  onClose: (success: boolean) => void;
}

const DeliveryUnitSaleCatalogPreviewOrderDialog: React.FC<IProps> = ({
  party,
  deliveryUnitId,
  itemCustomisations,
  onClose
}: IProps) => {
  const {
    data: previewData,
    loading: previewLoading
  } = GQLOperationBuilder.deliveryUnit.getPlatformProducerOrderAndProductionPlanPreview({
    producerPartyId: party.id,
    producerDeliveryUnitId: deliveryUnitId,
    itemCustomisations: itemCustomisations
  });

  if (previewLoading) return <LoadingSpinner />;

  const orderWithPlan = GQLOperationBuilder.deliveryUnit.getPlatformProducerOrderAndProductionPlanFromResponse(
    previewData
  );

  return (
    <Fragment>
      <Dialog open maxWidth="md" aria-labelledby="producer-order-preview">
        <DialogTitle>Producer order preview</DialogTitle>
        <DialogContent className="w-dialog-big">
          <DialogActions>
            <Button color="primary" onClick={() => onClose(false)}>
              Close
            </Button>
          </DialogActions>
          <PlatformProducerOrderWithProductionPlanDetails
            order={orderWithPlan.platformProducerOrder}
            productionPlan={orderWithPlan.platformProducerOrderProductionPlan}
          />
        </DialogContent>
      </Dialog>
    </Fragment>
  );
};

export default DeliveryUnitSaleCatalogPreviewOrderDialog;
